(function() {
  var UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var STORAGE_KEY = 'shopify_utm_data';
  var EXPIRY_DAYS = 30;

  function getUrlParams() {
    var params = {};
    var search = window.location.search.substring(1);
    if (!search) return params;
    var pairs = search.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      var key = decodeURIComponent(pair[0]);
      var value = decodeURIComponent(pair[1] || '');
      if (UTM_PARAMS.indexOf(key) !== -1 || key === 'fbclid' || key === 'gclid' || key === 'ttclid' || key === 'msclkid') {
        params[key] = value;
      }
    }
    return params;
  }

  function getReferrerSource() {
    var ref = document.referrer;
    if (!ref) return null;
    try {
      var refHost = new URL(ref).hostname.toLowerCase();
      var currentHost = window.location.hostname.toLowerCase();
      if (refHost === currentHost) return null;

      if (refHost.indexOf('facebook') !== -1 || refHost.indexOf('fb.com') !== -1) return 'facebook';
      if (refHost.indexOf('instagram') !== -1) return 'instagram';
      if (refHost.indexOf('tiktok') !== -1) return 'tiktok';
      if (refHost.indexOf('google') !== -1) return 'google';
      if (refHost.indexOf('bing') !== -1) return 'bing';
      if (refHost.indexOf('youtube') !== -1) return 'youtube';
      if (refHost.indexOf('chat.openai.com') !== -1 || refHost.indexOf('chatgpt.com') !== -1) return 'chatgpt';
      if (refHost.indexOf('twitter') !== -1 || refHost.indexOf('x.com') !== -1) return 'twitter';
      if (refHost.indexOf('linkedin') !== -1) return 'linkedin';
      if (refHost.indexOf('reddit') !== -1) return 'reddit';
      if (refHost.indexOf('pinterest') !== -1) return 'pinterest';
      return refHost;
    } catch (e) {
      return null;
    }
  }

  function saveData(data) {
    var expiry = new Date();
    expiry.setDate(expiry.getDate() + EXPIRY_DAYS);
    var payload = {
      data: data,
      expiry: expiry.getTime()
    };
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      document.cookie = STORAGE_KEY + '=' + encodeURIComponent(JSON.stringify(data)) +
        '; expires=' + expiry.toUTCString() + '; path=/; SameSite=Lax';
    } catch (e) {}
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
      try { return JSON.parse(decodeURIComponent(match[2])); } catch (e) { return null; }
    }
    return null;
  }

  function loadData() {
    try {
      var session = sessionStorage.getItem(STORAGE_KEY);
      if (session) {
        var parsed = JSON.parse(session);
        if (parsed.expiry > new Date().getTime()) return parsed.data;
      }
    } catch (e) {}
    return getCookie(STORAGE_KEY);
  }

  function attachToCart(data) {
    if (!data || Object.keys(data).length === 0) return;
    var attributes = {};
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        attributes['attributes[_' + key + ']'] = data[key];
      }
    }
    attributes['attributes[_landing_page]'] = window.location.pathname;
    attributes['attributes[_first_visit_at]'] = new Date().toISOString();

    var formData = new FormData();
    for (var k in attributes) {
      formData.append(k, attributes[k]);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    }).catch(function() {});
  }

  function init() {
    var existing = loadData() || {};
    var fresh = getUrlParams();
    var refSource = getReferrerSource();

    var hasFreshUtm = Object.keys(fresh).length > 0;

    if (hasFreshUtm) {
      existing = fresh;
      if (refSource && !existing.utm_source) existing.utm_source = refSource;
    } else if (refSource && !existing.utm_source) {
      existing.utm_source = refSource;
      existing.utm_medium = 'referral';
    } else if (!refSource && Object.keys(existing).length === 0) {
      existing.utm_source = 'direct';
      existing.utm_medium = 'none';
    }

    saveData(existing);
    attachToCart(existing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();